import React from 'react';
import { Heart } from 'lucide-react';
import Reveal from './Reveal';

/** Apple Watch: records the session; heart rate stays on the wrist and in Apple Health. */
const Watch = () => (
  <section id="watch" className="section section-night" aria-labelledby="watch-headline">
    <div className="section-inner split split-reverse">
      <Reveal>
        <div
          className="watch"
          role="img"
          aria-label="Apple Watch during a session: Swing EMOM, minute 7 of 10, 15 reps at 16 kg, with the heart rate shown on the wrist."
        >
          <div className="watch-screen" aria-hidden="true">
            <div className="watch-label">Swing EMOM</div>
            <div className="watch-big">7/10</div>
            <div className="watch-sub">15 reps · 16 kg</div>
            <div className="watch-hr">
              <Heart size={15} fill="currentColor" strokeWidth={0} className="watch-heart" /> 142
            </div>
          </div>
        </div>
      </Reveal>
      <Reveal>
        <p className="eyebrow">Apple Watch</p>
        <h2 id="watch-headline" className="h2">
          Leave the phone on the shelf.
        </h2>
        <p className="lead-sm">
          The optional Apple Watch app (watchOS 27) takes you through the session block by block and
          records it. When you are done, the workout is saved to Apple Health and your log - even
          with no signal.
        </p>
        <p className="lead-sm">
          <strong>Your heart rate stays on your wrist and in Apple Health.</strong> It never leaves
          your devices, your crew never sees it, no notification shows it, and it is never used for
          advertising.
        </p>
      </Reveal>
    </div>
  </section>
);

export default Watch;
